import React, { FC } from 'react';
import { Image } from '../Image';
import style from './CooperativeEnterprise.module.scss';

interface Props {
  title: string;
  moTitle: string;
  declaration: string;
  enterpriseList: string[];
}

const CooperativeEnterprise: FC<Props> = function CooperativeEnterprise({
  title,
  moTitle,
  declaration,
  enterpriseList,
}) {
  return (
    enterpriseList && (
      <div className={style['cooperative-enterprise-container']}>
        <div className={style['cooperative-enterprise-title']}>
          <span className="hidden lg:inline">{title}</span>
          <span className="inline leading-7 lg:hidden">{moTitle}</span>
        </div>
        <div className={style['cooperative-enterprise-list']}>
          {enterpriseList.map((enterprise, idx) => (
            <div key={idx} className={style['cooperative-enterprise']}>
              <Image src={enterprise} layout="fill" />
            </div>
          ))}
        </div>
        <div className={style['cooperative-enterprise-declaration']}>{declaration}</div>
      </div>
    )
  );
};

export default CooperativeEnterprise;
